import { IsNotEmpty, IsString } from 'class-validator';

export class MobileNumberDto {
  @IsString()
  @IsNotEmpty()
  mobileNumber!: string;
}
